<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  quiz: {
    logo?: string;
    title?: string;
    sub_title?: string;
    legal_name?: string;
    legal_id?: string;
    disclaimer?: string;
    privacy_url?: string;
    privacy_text?: string;
  };
  progress: { current: number; total: number };
  canGoBack: boolean;
  showHero: boolean;
  isGate: boolean;
}>();
</script>

<template>
  <div class="tpl-zro">
    <header class="tpl-zro__band tpl-zro__band--top">
      <img v-if="quiz.logo" :src="quiz.logo" alt="logo" class="tpl-zro__logo" />
    </header>

    <main class="tpl-zro__main">
      <div v-if="showHero" class="tpl-zro__hero">
        <h1 class="tpl-zro__hero-title">{{ quiz.title }}</h1>
        <p v-if="quiz.sub_title" class="tpl-zro__hero-sub">({{ quiz.sub_title }})</p>
      </div>

      <div v-if="!isGate" class="tpl-zro__progress-track">
        <div
          class="tpl-zro__progress-fill"
          :style="{ width: (progress.total ? (progress.current / progress.total) * 100 : 0) + '%' }"
        ></div>
      </div>
      <p v-if="!isGate" class="tpl-zro__progress-label">{{ progress.current }} - {{ progress.total }}</p>

      <slot />
    </main>

    <footer class="tpl-zro__band tpl-zro__footer">
      <div class="tpl-zro__footer-links">
        <a v-if="quiz.privacy_url" :href="quiz.privacy_url" target="_blank">
          {{ quiz.privacy_text || 'Privacy Policy' }}
        </a>
      </div>
      <p v-if="quiz.legal_name" class="tpl-zro__footer-legal">
        © {{ quiz.legal_name }}<template v-if="quiz.legal_id"> - {{ quiz.legal_id }}</template>
      </p>
      <p v-if="quiz.disclaimer" class="tpl-zro__footer-disclaimer">{{ quiz.disclaimer }}</p>
    </footer>
  </div>
</template>
